import React from 'react';
import { Box, Grid, SvgIcon, Typography } from '@mui/material';
import SearchPluginModal from './SearchPluginModal';
import ConnectionTableAccordion from './ConnectionTableAccordion';
import SparkSearchContextProvider from 'components/Providers/ContextProviders/SparkSearchContextProvider';

import AddConnectionPluginAuthentication from './AddConnectionPluginAuthentication';
import { PlusIcon } from 'components/SVG';
import { SparkButton, SparkDialog } from 'sharedComponents/UI';
import { useDialog, useResize } from 'hooks/common';
import type { Plugins } from 'types/Plugins';
import type { PluginAuthentication } from 'types/PluginAuthentications';

function Connections() {
  const {
    open: isPluginSearchModalOpen,
    openDialog: openPluginSearchDialog,
    closeDialog: closePluginSearchDialog,
  } = useDialog();

  const { isMobile } = useResize();

  const {
    open: isAuthenticationModalOpen,
    openDialog: openAuthenticationModal,
    closeDialog: closeAuthenticationModal,
  } = useDialog();

  const [selectedPlugin, setSelectedPlugin] = React.useState<{
    plugin: Plugins | undefined;
    pluginConnections: number | undefined;
    pluginAuthentications: PluginAuthentication[] | undefined;
  }>();

  const handleAddConnection = () => {
    openPluginSearchDialog();
  };

  const handleSelectedPlugin = (
    selectedPlugin:
      | {
          plugin: Plugins | undefined;
          pluginConnections: number | undefined;
          pluginAuthentications: PluginAuthentication[] | undefined;
        }
      | undefined
  ) => {
    setSelectedPlugin(selectedPlugin);
    closePluginSearchDialog();
    openAuthenticationModal();
  };

  const selectedPluginAuthentications = selectedPlugin?.pluginAuthentications;

  return (
    <Grid container padding={isMobile ? 2 : 3}>
      <Box display={'flex'} justifyContent={'space-between'} width={'100%'}>
        <Typography
          variant='h4'
          sx={{
            color: '#404040',
            fontFamily: 'Mont-semibold',
          }}
        >
          Connections
        </Typography>
        <SparkButton
          variant='contained'
          startIcon={
            <SvgIcon
              sx={{
                '& path': {
                  fill: 'white',
                },
                stroke: 'white',
              }}
            >
              <PlusIcon color='white' width='22' height='22' />
            </SvgIcon>
          }
          onClick={handleAddConnection}
        >
          <Typography variant='body1'>Add Connection</Typography>
        </SparkButton>
      </Box>
      <Box width={'100%'}>
        <SparkSearchContextProvider>
          <ConnectionTableAccordion />
        </SparkSearchContextProvider>
      </Box>
      {isPluginSearchModalOpen && (
        <SparkDialog
          onClose={closePluginSearchDialog}
          title='Search Plugin'
          open={isPluginSearchModalOpen}
        >
          <SearchPluginModal selectPlugin={handleSelectedPlugin} />
        </SparkDialog>
      )}
      {selectedPlugin && selectedPluginAuthentications && (
        <AddConnectionPluginAuthentication
          pluginAuthentications={selectedPluginAuthentications}
          selectedPlugin={selectedPlugin}
          isModalOpen={isAuthenticationModalOpen}
          handleClose={closeAuthenticationModal}
        />
      )}
    </Grid>
  );
}

export default Connections;
